import { useSelector } from "react-redux";
import { getFareOffersWithDetails } from "../../store/brandedFareOffers/selectors";

export default function useBrandedFares(baseOfferToken: string) {
  const fareOffersWithDetails = useSelector(getFareOffersWithDetails);
  return fareOffersWithDetails?.[baseOfferToken] || {};
}
